import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { mobileDevelopmentPageSeo } from './MobileDevelopmentPage.seo';
import type { MobileDevelopmentPageProps } from './MobileDevelopmentPage.types';
import { MobileServices } from './MobileServices';
import { OurWork } from './OurWork';
import { Testimonial } from './Testimonial';

export const MobileDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: MobileDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...mobileDevelopmentPageSeo} />

      <Hero />
      <MobileServices />
      <Testimonial />
      <Benefits />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to Mobile Development!"
        color="purple"
      />
    </Layout>
  );
};
